import { Flex } from "antd";
import { GoogleLoginButton } from "./GoogleLoginButton";
import { OauthFlowAction } from "types";
import { AppleLoginButton } from "./AppleLoginButton";

export const socialBtnStyle: React.CSSProperties = {
  width: "100%",
  height: 44,
  background: "white",
  border: "1px solid #e5e7eb",
  borderRadius: 8,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 10,
  fontSize: 14,
  fontFamily: "'Inter Variable', sans-serif",
  fontWeight: 400,
  color: "#374151",
  boxShadow: "none",
};

export const SocialLogin = ({
  containerStyle,
  action,
}: {
  containerStyle?: React.CSSProperties;
  action: OauthFlowAction;
}) => {
  return (
    <Flex
      justify="center"
      align="center"
      vertical
      gap={12}
      style={{
        position: "relative",
        width: "100%",
        ...containerStyle,
      }}
    >
      <GoogleLoginButton action={action} size="large" style={socialBtnStyle} />
      <AppleLoginButton action={action} size="large" style={socialBtnStyle} />
    </Flex>
  );
};
